import React, { Component } from 'react';
import { TextInput } from 'telstra-ui/components/text-input/TextInput';
import { ToggleButton } from 'telstra-ui/components/toggle/ToggleButton';
import { Accordion } from 'telstra-ui/components/accordion/Accordion';
import { Button } from 'telstra-ui/components/button/Button';
import { Divider } from 'telstra-ui/components/divider/Divider';
import { GenericAlert } from 'telstra-ui/components/generic-alert/GenericAlert';
import {
  validateNumber,
  scrollMatchingElementIntoView,
  scrollElementIntoView,
} from '../../../ssm-homepage/ssm-homepage.actions';
import { prepareToggleOptionsArry, getTitleChart, validatePlanListData } from '../../adaptive-mobility-external.actions';
import DisplayCostAndDataAllowance from '../display-cost-and-data-allowance/display-cost-and-data-allowance';
import { isMobile } from '../../../../app-responsive';
import './input-Fields.css';

class InputFields extends Component {
  constructor() {
    super();
    this.state = {
      planListData: [],
      showErrorMessage: false,
    };
    this.addAnotherPlan = this.addAnotherPlan.bind(this);
  }

  componentDidMount() {
    if (this.props.planListData.length > 0) {
      this.updatePlanListState(this.props.planListData);
    } else {
      this.addAnotherPlan();
    }
  }

  onChangeUsageLevel = (event) => {
    const selectedValue = event.target.getAttribute('data-item');
    const planListData = this.state.planListData;
    const dataIndex = event.target.parentElement.parentElement.getAttribute('id').split('-')[1];
    planListData[dataIndex].usageLevel = selectedValue;
    this.setState({ planListData });
  }

  onChangeInputFields = (event) => {
    this.props.clearResults();
    const selectedValue = event.target.value;
    const planListData = this.state.planListData;
    const [dataIndex, type] = event.target.id.split('-');
    if (type === 'cost' || type === 'dataAllowance' || type === 'numberOfDevices') {
      if (validateNumber(event.target.value)) {
        planListData[dataIndex][type] = selectedValue;
        this.setState({ planListData });
      }
    } else {
      planListData[dataIndex][type] = selectedValue;
      this.setState({ planListData });
    }
  }
  onShowResult = () => {
    const validationResult = validatePlanListData(this.state.planListData);
    if (validationResult) {
      this.setState({ showErrorMessage: false });
      this.props.showResultClickHandler(this.state.planListData);
      setTimeout(() => {
        scrollMatchingElementIntoView('.cost-data-allowance-section');
      }, 50);
    } else {
      this.setState({ showErrorMessage: true });
    }
  }

  updatePlanListState = (planListData) => {
    this.setState({ planListData });
  }


  removePlan = (event) => {
    this.props.clearResults();
    const indexId = event.target.id;
    const planListData = this.state.planListData;
    delete planListData[indexId];
    const newList = planListData.filter(plan => plan !== null);
    const newListWithIndexAdjusted = newList.map((newPlan, index) => {
      const newPlanId = `Plan-${getTitleChart(index)}`;
      return { ...newPlan, index, id: newPlanId };
    });
    setTimeout(() => {
      this.setState({ planListData: newListWithIndexAdjusted });
    }, 100);
  };

  handleOnselectDataOnly = (event) => {
    this.props.clearResults();
    const planListData = this.state.planListData;
    const dataIndex = event.id.split('-')[1];
    planListData[dataIndex].dataOnly = event.value;
    this.setState({ planListData });
  }

  addAnotherPlan() {
    this.props.clearResults();
    const planListData = this.state.planListData;
    const newArrayIndex = (planListData.length <= 0) ? 0 : planListData.length;
    const planId = `Plan-${getTitleChart(newArrayIndex)}`;
    planListData.push({
      index: newArrayIndex,
      id: planId,
      cost: '',
      dataAllowance: '',
      numberOfDevices: '',
      usageLevel: '',
      dataOnly: 'No',
    });
    this.setState({ planListData });
    if (isMobile && planListData.length > 1) {
      setTimeout(() => {
        scrollElementIntoView(`planDataOnly-${newArrayIndex > 0 ? newArrayIndex - 1 : 0}`);
      }, 50);
    }
  }

  displayHtml = (title, id, index, numberOfPlans) => {
    const {
      cost,
      allowance,
      devices,
      dataOnly,
      planDetails: {
        removePlanText,
      },
    } = this.props.authorableContent;

    return (
      <div className="paln-item" key={id}>
        <div className="row">
          <div className="col-md-8 plan-title">
            <div className="heading24 title">{title}</div>
          </div>
          <div className="col-md-4 text-right remove-btn">
            { numberOfPlans > 1 &&
              <Button
                variant="primary"
                id={index}
                onClick={this.removePlan}
                size="medium"
                iconPosition="right"
                className="plan-close-icon"
              >
                {removePlanText}
              </Button>
            }
          </div>
        </div>
        <Divider className="tl-light-grey" />
        <div className="row marginS mb-0">
          <div className="col-md-3 col-sm-12 text-field">
            <TextInput
              name={`${id}-numberOfDevices`}
              id={`${index}-numberOfDevices`}
              className="heading16"
              label={devices.label}
              value={this.state.planListData[index].numberOfDevices}
              onChange={this.onChangeInputFields}
            />
          </div>
          <div className="col-md-3 col-sm-12 text-field">
            <TextInput
              name={`${id}-cost`}
              id={`${index}-cost`}
              className="heading16"
              label={cost.label}
              assistiveText={cost.placeholder}
              value={this.state.planListData[index].cost}
              onChange={this.onChangeInputFields}
            />
          </div>

          <div className="col-md-3 col-sm-12 text-field">
            <TextInput
              name={`${id}-dataAllowance`}
              id={`${index}-dataAllowance`}
              className="heading16"
              label={allowance.label}
              assistiveText={allowance.placeholder}
              value={this.state.planListData[index].dataAllowance}
              onChange={this.onChangeInputFields}
            />
          </div>
          <div className="col-md-3 col-sm-12 text-field">
            <span className="heading16">{dataOnly.label}</span>
            <ToggleButton
              className="plan-data-selection"
              size="large"
              name={`${id}-dataOnly`}
              value={this.state.planListData[index].dataOnly}
              options={prepareToggleOptionsArry(dataOnly.options, `planDataOnly-${index}`)}
              selectionMode="single"
              onChange={this.handleOnselectDataOnly}
            />
          </div>
        </div>
      </div>
    );
  };

  resetPlan = () => {
    this.setState({ planListData: [], showErrorMessage: false }, () => {
      this.addAnotherPlan();
    });
  };

  render() {
    const {
      authorableContent: {
        planDetails,
        planErrorMessage,
        planDetails: {
          addAnotherPlanText,
          resetCalculatorText,
          planListText,
          planText,
          showResultText,
        },
      },
      inputLimit,
      calculationInProgress,
    } = this.props;

    return (
      <div className="plan-fields-section paddingS pl-0 pr-0">
        <div className="input-fields-section">
          <Accordion
            exclusive={false}
            items={[{
              className: 'accordion-head',
              header: planListText,
              startOpen: true,
              content: <div className="plan-list">
                {this.state.planListData.length >= 0 && this.state.planListData.map((data) => {
                  const title = `${planText} ${getTitleChart(data.index)}`;
                  return this.displayHtml(title, data.id, data.index, this.state.planListData.length);
                })}
                <div className="row button-section paddingS pl-0 pr-0">
                  <div className="col-md-3">
                    <Button
                      variant="super"
                      className="add-another-plan"
                      onClick={this.addAnotherPlan}
                      disabled={this.state.planListData.length >= inputLimit}
                    >
                      {addAnotherPlanText}
                    </Button>
                  </div>
                  <div className="col-md-3">
                    <Button
                      variant="primary"
                      onClick={this.resetPlan}
                      size="medium"
                      iconPosition="right"
                      className="plan-reset-btn"
                    >
                      {resetCalculatorText}
                    </Button>
                  </div>
                </div>
                {this.state.showErrorMessage &&
                  <div className="error-section paddingS pl-0 pr-0">
                    <GenericAlert
                      name="warning-noBackground"
                      description={planErrorMessage}
                      showBackground
                    />
                  </div>
                }
              </div>,
            }]}
          />
        </div>
        <DisplayCostAndDataAllowance
          authorableContent={planDetails}
          planListData={this.state.planListData}
        />
        <div className="row show-result-section paddingS pb-0 pl-0 pr-0">
          <div className="col-sm-12 col-md-3 text-left">
            <Button
              variant="super"
              className="show-result-btn"
              onClick={this.onShowResult}
              state={calculationInProgress ? 'loading' : 'app'}
            >
              {showResultText}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default InputFields;
